// extracted by mini-css-extract-plugin
export default {"pageTitle":"BoardGameWaitingRoom_pageTitle__B7CWU","roomList":"BoardGameWaitingRoom_roomList__2405v","roomMember":"BoardGameWaitingRoom_roomMember__8jiWJ"};